import { Outlet } from "react-router-dom";

import AppAppBar from "../Components/AppAppBar";
import Footer from "../Components/Footer";
import { useAuth } from "../hooks/useAuth";

import Banner from "../Components/Banner";
import "../App.css";

function RootLayout() {
  const { authed, profile } = useAuth();

  function profileIsIncomplete() {
    return authed && (!profile?.favorite_food || !profile?.bio);
  }
  return (
    <>
      {profileIsIncomplete() && (
        <Banner message="🍜 Add your favorite dish and a short bio in your profile. Let fellow foodies get to know the real you!" />
      )}
      <AppAppBar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

export default RootLayout;
